<template>
    <div class="chat-view-container">
      <Chat 
        :show-desktop-layout="showDesktopLayout"
        @message-sent="handleMessageSent"
        @message-deleted="handleMessageDeleted"
        @messages-cleared="handleMessagesCleared"
        ref="chatComponent"
      />
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import Chat from '@/common/components/chat/chat-ai.vue'
  
  // Props
  const props = defineProps({
    showDesktopLayout: {
      type: Boolean,
      default: false
    }
  })
  
  // Emits - proslijedi events dalje ako je potrebno
  const emit = defineEmits(['message-sent', 'message-deleted', 'messages-cleared'])
  
  // Ref za chat komponentu
  const chatComponent = ref(null)
  
  // Event handlers
  const handleMessageSent = (data) => {
    console.log('📨 Message sent:', data)
    emit('message-sent', data)
  }
  
  const handleMessageDeleted = (messageId) => {
    console.log('🗑️ Message deleted:', messageId)
    emit('message-deleted', messageId)
  }
  
  const handleMessagesCleared = () => {
    console.log('🧹 All messages cleared')
    emit('messages-cleared')
  }
  
  // Expose chat methods if needed by parent
  const sendMessage = () => {
    chatComponent.value?.sendMessage()
  }
  
  const deleteAllMessages = () => {
    chatComponent.value?.deleteAllMessages()
  }
  
  const scrollToBottom = () => {
    chatComponent.value?.scrollToBottom()
  }
  
  defineExpose({
    sendMessage,
    deleteAllMessages,
    scrollToBottom
  })
  </script>
  
  <style scoped>
  .chat-view-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  
  /* Možete dodati dodatne wrapper stilove ovdje ako je potrebno */
  </style>